<template>
  <div class="article-views">
    <SvgAsset
      class="article-views__eye"
      :content="viewsPath"
    />
    <span class="article-views__views-count"> {{ article.views }} </span>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  import type { IFullArticle, TArticle } from '~/types/common';
  import SvgAsset from '@devhacker/shared/components/SvgAsset.vue';
  import viewsPath from '@/assets/images/svg/views.svg?raw';

  export default defineNuxtComponent({
    name: 'ArticleViews',

    components: { SvgAsset },

    props: {
      article: {
        type: Object as PropType<IFullArticle | TArticle>,
        required: true,
      },
    },

    computed: {
      viewsPath: () => viewsPath,
    },
  });
</script>

<style lang="scss" scoped>
  .article-views {
    background-color: #ffffff;
    border: 1px solid #e7e7e7;
    box-shadow: 0px 8px 14px rgba(0, 0, 0, 0.05);
    border-radius: 40px;
    padding: 10px $spacing-2;
    display: flex;
    align-items: center;
    cursor: default;

    @include hover {
      border-color: black;

      .article-views__eye,
      .article-views__views-count {
        color: black;
      }
    }

    &__eye {
      display: flex;
      width: 16px;
      height: 16px;
      margin-right: 5px;
      color: #4c4c4c;
    }

    &__views-count {
      color: #969698;
      font-family: $text-font--1;
      @include smallText;
    }
  }
</style>
